import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import IconWarning from '../../assets/icon-warning.svg';
import { setIdleTimer } from '../../app/store/majesticSlice';
import usePageNavigation from '../../hooks/usePageNavigation';

function IdleTimerModal({ handleCloseModal = () => {} }) {
  const { idleTimer } = useSelector((state) => state.majestic);
  const { t } = useTranslation();
  const [show, setShow] = useState(false);

  const dispatch = useDispatch();

  const { nagivatePreviousPage } = usePageNavigation();

  const handleClose = () => {
    setShow(false);
    dispatch(setIdleTimer({}));
    handleCloseModal();

    if (idleTimer.action === 'INIT' /* errorOcr.status === 401 */) {
      nagivatePreviousPage('');
    }
  };
  // const handleShow = () => setShow(true);

  useEffect(() => {
    setShow(true);
  }, []);

  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      contentClassName="border-0"
      centered
    >
      <Modal.Header className="pt-3 pb-0 border-0">
        <Modal.Title className="mx-auto text-center">
          <img src={IconWarning} alt="icon-warning" className="pb-3" />
          <p className="mb-0 app-fw-notosans-bold">{t('TXT_TITLE_NOTICE')}</p>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="pt-1">
        <p className="mb-0 app-txt-granite-80-dark text-center app-fs-15 app-lh-h4">
          {t('TXT_ERROR_IDLETIMER_UNACTIVE')}
        </p>
      </Modal.Body>
      <Modal.Footer className="border-0 mx-auto">
        <Button
          variant=""
          onClick={handleClose}
          className="app-bg-sand app-fw-notosans-bold app-txt-granite w-100 rounded-3 btn-height px-4"
        >
          {t('TXT_BTN_ACCEPT')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default IdleTimerModal;
